import { Project } from "pmt-types/src/models/Project.ts";
import { PagedApiData } from "pmt-types/src/utils/PagedApiData.ts";
import { useQuery } from "react-query";
import { Maybe } from "../../utils/types/maybe.ts";
import { useAuthentication } from "../useAuthentication.ts";
import { QueryKeys } from "./queryKeys.ts";

export const useQueryGetProjectsForSourceId = (sourceId: Maybe<string>) => {
  const { accessToken } = useAuthentication();

  return useQuery(
    [QueryKeys.GetSourceProjects, sourceId],
    async () => {
      const response = await fetch(
        `${import.meta.env.VITE_API_HOST}/sources/${sourceId}/projects`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: accessToken ?? "",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to query source projects");
      }

      const apiData = (await response.json()) as PagedApiData<Project>;

      return apiData?.data ?? [];
    },
    {
      enabled: sourceId != null && sourceId !== "new",
      onError: (error) => {
        console.error("Failed to get projects for source", error, sourceId);
      },
    },
  );
};
